import { render } from "./StudentEdit.vue?vue&type=template&id=43e4e4b1&scoped=true&ts=true"
import script from "./StudentEdit.vue?vue&type=script&lang=ts"
export * from "./StudentEdit.vue?vue&type=script&lang=ts"

import "./StudentEdit.vue?vue&type=style&index=0&id=43e4e4b1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e4e4b1"]])

export default __exports__